import React, { createContext, useContext, useEffect, useState } from "react";
import {
  CACHE_KEYS,
  CACHE_TTL,
  fetchCachedJson,
  getCached,
} from "../utils/apiCache";

const PortfolioDataContext = createContext(null);

const PORTFOLIO_API = "/.netlify/functions/portfolio-data";

export function PortfolioDataProvider({ children }) {
  const [data, setData] = useState(() => getCached(CACHE_KEYS.portfolio));
  const [loading, setLoading] = useState(() => !getCached(CACHE_KEYS.portfolio));
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadPortfolioData() {
      try {
        const portfolioData = await fetchCachedJson(
          PORTFOLIO_API,
          CACHE_KEYS.portfolio,
          CACHE_TTL.portfolio
        );

        if (!cancelled) {
          setData(portfolioData);
          setError(null);
        }
      } catch (fetchError) {
        if (!cancelled) {
          setError(fetchError.message || "Unable to load portfolio content.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadPortfolioData();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <PortfolioDataContext.Provider value={{ data, loading, error }}>
      {children}
    </PortfolioDataContext.Provider>
  );
}

export function usePortfolioData() {
  const context = useContext(PortfolioDataContext);

  if (!context) {
    throw new Error("usePortfolioData must be used within PortfolioDataProvider");
  }

  return context;
}
